import { LAYOUTS, POSITION, } from "@voltmoney/types";
import { WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../routes";
import { ACTION } from "./types";
import { goBack, needHelp } from "./actions";
import { getKFSData, getLenderInfo } from "../../configs/utils";
import { isDarkModeTheme } from "../../configs/config";
let isDarkMode = isDarkModeTheme();
export const template = (height, kfs_data, lenderInfo) => ({
    layout: {
        id: ROUTE.KFS_SCREEN,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true
        },
        widgets: [
            {
                id: "customHeader",
                type: WIDGET.CUSTOM_HEADER,
                position: POSITION.ABSOLUTE_TOP,
            },
            {
                id: 'KFS_Screen_Page',
                type: WIDGET.KFS_PAGE,
            },
        ],
    },
    datastore: {
        KFS_Screen_Page: {
            height: height,
            kfs_data: kfs_data,
            isDarkMode: isDarkMode ? true : false,
            lenderData: lenderInfo,
            goBack: {
                routeId: ROUTE.KFS_SCREEN,
                type: ACTION.GO_BACK,
                payload: {}
            }
        },
        customHeader: {
            title: "Key fact statement",
            isDarkMode: isDarkMode ? true : false,
            needHelpAction: {
                routeId: ROUTE.KFS_SCREEN,
                type: ACTION.NEED_HELP,
                payload: {}
            },
            goBackAction: {
                routeId: ROUTE.KFS_SCREEN,
                type: ACTION.GO_BACK,
                payload: {}
            },
        },
    },
});
export const kfsScreenMF = {
    onLoad: async ({ getHeight, network }) => {
        const lenderInfo = await getLenderInfo(network);
        const kfs_Data = await getKFSData(network);
        return Promise.resolve(template(getHeight(), kfs_Data, lenderInfo));
    },
    actions: {
        [ACTION.GO_BACK]: goBack,
        [ACTION.NEED_HELP]: needHelp,
    },
};
